
import { Input } from "@/components/ui/input";

interface ContactFormInputProps {
  id: string;
  name: string;
  label: string;
  type?: string;
  placeholder: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  className?: string;
}

export const ContactFormInput = ({
  id,
  name,
  label,
  type = "text",
  placeholder,
  value,
  onChange,
  required = false,
  className = "",
}: ContactFormInputProps) => {
  return (
    <div>
      <label htmlFor={id} className="block text-sm font-medium mb-2 text-[#0c4a6e]">
        {label}
      </label>
      <Input
        id={id}
        name={name}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        required={required}
        className={`w-full rounded-md border-[#bae6fd] ${className}`}
      />
    </div>
  );
};
